import { Expose } from 'class-transformer';
import { IsOptional, IsString } from 'class-validator';

export class UpdateOrderPODto {
  @IsString()
  @IsOptional()
  @Expose()
  poNumber?: string;
}
